import { mapWidgetModel, getDataFromModel } from '../../../helpers/models';

export default function* addPortalSaga(getFirebase, action) {
  const { payload: { projectId, widget } } = action;
  try {
    getDataFromModel(widget, mapWidgetModel);
    yield getFirebase().updateWithMeta(`/projects/${projectId}/map/widgets/${widget.id}`, widget);
  } catch (err) {
    console.log('Error in saga!:', err);
  }
}



// WEBPACK FOOTER //
// ./src/redux/sagas/map/UpdateWidgetSaga.js